module.exports = __webpack_public_path__ + "img/grayscale_high.bd43f659.webp";